
import { computed, defineComponent, PropType } from 'vue'
import { InvoiceSearchFilter } from '@/views/_shared/search-list/types'
import InvoicesFormFieldStatus from '@/components/invoices/form-fields/status.vue'
import InvoicesFormFieldAgreementName from '@/components/invoices/form-fields/agreement-name.vue'
import InvoicesFormFieldOrganization from '@/components/invoices/form-fields/organization.vue'
import InvoicesFormFieldSearch from '@/components/invoices/form-fields/search.vue'
import InvoicesFormFieldDateFrom from '@/components/invoices/form-fields/date-from.vue'
import InvoicesFormFieldDateTo from '@/components/invoices/form-fields/date-to.vue'

export default defineComponent({
    name: 'invoices-filter',
    components: {
        InvoicesFormFieldSearch,
        InvoicesFormFieldStatus,
        InvoicesFormFieldAgreementName,
        InvoicesFormFieldOrganization,
        InvoicesFormFieldDateFrom,
        InvoicesFormFieldDateTo
    },
    props: {
        modelValue: {
            type: Object as PropType<InvoiceSearchFilter>,
            required: true
        }
    },
    async setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            localModel
        }
    }
})
